import { ShopCartType } from './cart.types';

export enum StarredItems {
  Services = 1000,
  Products = 2000,
  Locations = 3000,
  Provider = 4000
}

export enum AppointmentsType {
  all = 'all',
  past = 'past',
  future = 'future'
}

export type UpdateClDetailsParams = {
  bday_date?: string;
  email?: string;
  gender?: string;
  givname?: string;
  nickname?: string;
  ph_home?: string;
  ph_mobile?: string;
  ph_work?: string;
  surname?: string;
};

export interface RecentServiceInterface {
  appt_id: number;
  svcid: number;
  svc_name: string;
  svc_date: string;
  svc_time: string;
  series_start_dt: string;
  series_end_dt: string;
  is_dropin: number;
  locid: number;
  loc_name: string;
  departmentid: number | null;
  department_name: string | null;
  emid: number;
  em_name: string;
  em_id_list: string;
  em_names_list: string;
  retail: number;
  appt_svc_id: number;
  resource_id: string;
  resource_name: string;
  resource_id_list: string;
  resource_names_list: string;
  svc_dscr: string;
  svc_cat_id: number;
  svc_cat_name: string;
  svc_end_time: string;
  duration: string;
  min_attendees: number;
  max_attendees: number;
  allow_book: number;
  is_class: number;
  sv_parent_id: number | null;
  sv_parent_dscr: string;
  is_personal_schedule: number;
  is_live_stream_schedule: number;
  live_stream: number;
  live_stream_link: string;
  waiting_attendees_count: number;
  waiting_list_position: number;
  retail_price_applied: string;
  attendees_cnt: number;
  is_waiting_list: number;
  age_restricted: number;
  min_ages_unit: string;
  max_ages_unit: string;
  o_has_schedule_invitation: number;
  late_cancel_track: number;
  late_cancel_hrs: number;
  late_cancel_sv_inc: number;
  late_cancel_sv_cl: number;
  late_cancel_cl_free_inc: number;
  late_cancel_cl_free_cl: number;
  late_cancel_cl_paid_inc: number;
  late_cancel_cl_paid_cl: number;
  attendee_num: number;
  is_recurring: number;
  sessions_type: number;
  sessions_count: number;
  attendee_in_skip_cn_frame: number;
  related_cl_num: number;
  related_cl_name: string;
  em_photo_url: string;
  parent_locid: number | null;
  parent_loc_name: string | null;
  allow_cancel: number;
  allow_schedule: number;
  checkin_details: {
    item_status: number;
    checkin_ts: string | null;
    checkin_src: number;
    checkin_required: number;
    checkin_label: string;
    in_checkin_frame: number;
    checkin_start_ts: string | null;
    checkin_end_ts: string | null;
  };
  photo: string;
  item_type: string;
  assigned_em_list: {
    emid: string;
    em_name: string;
    em_photo_url: string;
  }[];
  min_age: number;
  max_age: number;
  age_restriction: string;
  cl_fav: number;
  fav_id: number;
  attendees: {
    rec_id: number;
    id: number;
    name: string;
    photo: string;
    is_personal_schedule: boolean;
    is_live_stream_schedule: boolean;
    price: string;
  }[];
  has_cancelation_fee: boolean;
  cancelation_data: {
    amount: number;
    is_house_account: number;
    is_credit_card: number;
    credit_card_type: string;
    credit_card_number: string;
  };
}

export interface UpcomingServiceInterface extends RecentServiceInterface {}

export interface ServiceHistoryInterface {
  svc_date: string;
  name: string;
  em_name: string;
  em_title: string;
  em_id: number;
  amount: number;
  id: number;
  store_id: number;
  cat_id: number;
  cat_name: string;
  kvxl_rebook: number;
  store_name: string;
  rel_svc_id: number | null;
  rel_svc_name: string | null;
  rel_svc_book_type: number;
}

export interface BookAgainServiceParams
  extends Pick<
    RecentServiceInterface,
    'locid' | 'svcid' | 'emid' | 'svc_cat_id'
  > {}

export type StarredItemType = {
  rel_id: number;
  item_type: number;
  item_num: number;
  name: string;
};

export interface RecentService {
  tz_offset: number;
  is_class: number;
  id: number;
  svc_num: number;
  svc_name: string;
  retail: string;
  svc_cat_num: number;
  svc_cat_name: string;
  startdate: string;
  starttime: string;
  enddate: string;
  endtime: string;
  resource_num: number | null;
  resource_name: string | null;
  service_order: number;
  allow_book: number;
  ps_type: string;
  provider_num: number;
  provider_photo: string;
  provider_name: string;
  provider_title: string;
  asst_provider_num: number;
  asst_provider_name: string;
}

export interface RecentAppointment {
  allow_book: number;
  confirmation_num: number;
  app_status_num: number;
  app_status_name: string;
  appt_start_dt: string;
  appt_start_tm: string;
  appt_end_dt: string;
  appt_end_tm: string;
  tz_offset: number;
  comments: string;
  store_num: number;
  store_name: string;
  store_fullname: string;
  addr1: string;
  addr2: string | null;
  city: string;
  province: string;
  postal: string;
  country: string;
  state: string;
  ph_bizhrs: string;
  phone: string;
  ph_service: string;
  email: string;
  is_waiting_list: number;
  item_status: number;
  appt_sv_attendee_id: number;
  sv_num: number;
  start_dt: string;
  start_tm: string;
  start_ts: string;
  appt_sv_id: number;
  provider_name: string;
  provider_num: number;
  provider_photo: string;
  past_appt: number;
  editable_appt: number;
  is_class: number;
  checkin_start_ts: string | null;
  checkin_end_ts: string | null;
  require_checkin: number;
  in_checkin_frame: number;
  equipment_id: number | null;
  equipment_name: string | null;
  equipment_location: string | null;
  equipment_glyph: string | null;
  equipment_symbol: string | null;
  client_id: number;
  client_name: string;
  request_confirmation: number;
  services: RecentService[];
  receipt_url?: string | null;
}

export interface UpcomingAppointment extends RecentAppointment {
  allow_cancel?: string | undefined;
  is_late_cancel?: string | undefined;
}

export interface RequiredFormInterface {
  form_id: number;
  form_name: string;
  svc_id: number;
  appt_id: number;
  appt_svc_id: number;
  required: 0 | 1;
  form_type: string;
  valid_for: number;
  frequency: number;
  form_key: string;
  appt_date: string;
  appt_store: number;
}

export interface PastFormInterface {
  sign_id: number;
  signed_date: string;
  signed_time: string;
  form_id: number;
  form_name: string;
  form_key: string;
  form_type: string;
  form_type_descr: string;
  em_id: number;
  form_view_url: string;
}

export interface FormDataInterface {
  form_id: number;
  form_type: string;
  rec_id: number | null;
  form_name: string;
  form_comment: string | null;
  base64: number;
  form_html: string;
  form_js: string;
  form_css: string;
  em_sig_req: number;
  cl_sig_req: number;
  required: number;
  is_signed: number;
  sign_id: number | null;
}

export enum MembershipStatus {
  Inactive,
  Active,
  Pending,
  Voided,
  Expired,
  Purchased,
  Refunded,
  Frozen,
  Terminated,
  Collection
}

export enum MembershipBillResult {
  unable_to_process,
  payment_processed,
  partial_payment_processed
}

export interface MembershipInterface {
  id: number;
  name: string;
  reccuring_amt: number;
  start_date: string;
  last_bill_result: MembershipBillResult;
  last_bill_result_text: string;
  next_bill_amt: number;
  next_bill_date: string;
  frozen_through_date: string;
  status: MembershipStatus;
  status_text: string;
  place?: string;
  tmpl_id?: number;
}

export interface MembershipDetailsInterface extends MembershipInterface {
  active_membership?: number;
  available_credit: number;
  balance_due: number;
  dscr: string;
  primary_cl_pymt_id: number;
  secondary_cl_pymt_id: number;
  unfreeze_fee_meth: number;
}

export type SiteAreaType = {
  id: number;
  name: string;
};

export enum SiteAlertPlacement {
  AboveSite = 'above-site',
  Standart = 'standard',
  Page = 'page'
}

export enum SiteAlertTarget {
  Sitewide = 'sitewide',
  SpecificPages = 'specific-pages'
}

export enum SiteAlertType {
  Notice = 'notice',
  Popup = 'popup',
  PopupText = 'popup_text',
  PopupLarge = 'popup-large',
  Url = 'url',
  UrlNewTab = 'url-new-tab'
}

export interface SiteAlertsInterface {
  id: number;
  site_alert_cat_id: number;
  site_alert_cat_name: string;
  name: string;
  text: string;
  popup_text: string;
  start_date: string | null;
  start_time: string | null;
  end_date: string | null;
  end_time: string | null;
  font_color: string;
  fill_color: string;
  font_size: number;
  url: string;
  priority: string | number;
  site_alert_type: SiteAlertType;
  site_alert_placement: SiteAlertPlacement;
  site_alert_target: SiteAlertTarget;
  site_area: SiteAreaType[];
}

export type RefCodeSubmitType = {
  givname: string;
  surname: string;
  phone: string;
  email: string;
};

export type ExecuteBalancePaymentParams = {
  amount: number;
  ccardid: number;
};

export interface ShopMembership {
  id: number;
  item_id: number;
  item_type: ShopCartType;
  name: string;
  code: string;
  category: string;
  dscr: string;
  dscr_line: string;
  dscr_line_1: string;
  dscr_line_2: string;
  dscr_line_3: string;
  cn_type: string;
  price: string;
  is_eft: number;
  montly_fee: string;
  startup_fee_allow: number;
  startup_fee: string;
  recurring_fee_allow: number;
  recurring_fee: number;
  recurring_type: string;
  min_term: string;
  taxable: number;
}

export interface ShopMembershipDetails extends ShopMembership {
  terms_public: string;
  ext_details: {
    amount: number;
    amount_due_today: number;

    amt_disc_usr: number;
    amt_min_price: number;
    amt_price_cta_meth: number;
    amt_sec_deposit: string;
    billing_day: number;
    cancellation_fee: number;
    cancellation_fee_allow: number;
    caretakers_adult_count_type: number;
    caretakers_adult_label: string;
    caretakers_adult_max: number;
    caretakers_adult_method: number;
    caretakers_adult_min: number;
    cn_sign_device: number;
    cn_sign_manual: number;
    cn_sign_sms: number;
    contract_type: string;
    credit_line_tmpl_id: number | null;
    dscr_line_1: string;
    dscr_line_2: string;
    exp_date: string;
    exp_meth: number;
    fee_this_month: number;
    first_billing_date: string;
    init_term: number;
    internal_dscr: string | null;
    is_locker: number;
    item_id: number;
    item_type: string;
    members_total_count_max: number;
    members_total_count_min: number;
    members_total_count_type: number;
    membership_dscr: string;
    membership_name: string;
    monthly_fee: number;
    pg_billamt_label: string;
    pg_billday_usr: number;
    pg_cancel_cycle_prior: number;
    pg_cancel_meth: number;
    pg_early_termination: number;
    pg_freeze_amt: number;
    pg_freeze_amt_usr: number;
    pg_freeze_extend_term: number;
    pg_freeze_limit: number;
    pg_freeze_limit_meth: number;
    pg_is_prorated: number;
    pg_renew_term: number;
    pg_renew_term_days: number;
    pg_term: number;
    pg_term_days: number | null;
    pg_term_usr: number;
    pg_unfreeze_fee_meth: number;
    prorate_amt: number;
    prorate_day_of_month: number;
    prorate_meth: number;
    public_dscr: string;
    recurring_fee_allow: number;
    renew_term: number;
    resp_party_meth: number;
    startup_fee: number;
    startup_fee_allow: number;
    startup_fee_label: string;
    store_access_meth: number;
    submembers_adult_count_type: number;
    submembers_adult_label: string;
    submembers_adult_max: number;
    submembers_adult_method: number;
    submembers_adult_min: number;
    submembers_kid_count_type: number;
    submembers_kid_label: string;
    submembers_kid_max: number;
    submembers_kid_method: number;
    submembers_kid_min: number;
  };
}

export enum CalendarType {
  google = 'google',
  apple = 'apple',
  yahoo = 'yahoo',
  outlook = 'outlook'
}

export enum SystemPreferencesType {
  REGISTRATION = 100,
  BOOK = 200
}

export interface SystemPreferencesFormType {
  trigger_type: number;
  form_type: string;
  form_id: number;
}

export interface SystemPreferencesResponse {
  sms_support: boolean;
  contact_phone: string;
  allow_consult_booking: boolean;
  show_svc_price: boolean;
  show_guest_svc_price: boolean;
  show_suggested_svc: boolean;
  allow_gc_purchase: boolean;
  allow_products_purchase: boolean;
  allow_guest_consult_booking: boolean;
  show_gratuity: boolean;
  allow_class_booking: boolean;
  show_packages: boolean;
  allow_packages_checkout: boolean;
  show_memberships: boolean;
  allow_memberships_checkout: boolean;
  allow_checkin: boolean;
  allow_guest_checkout: boolean;
  disable_all_payments: boolean;
  pymt_merchant_type: number;
  pymt_merchant_api_key: string;
  api_ver: string;
  ecomm_store_id: number;
  req_client_bday_meth: number;
  global_forms: SystemPreferencesFormType[];
}
